export const TOKEN_TYPE = "Bearer ";
export const REQUEST_HEADER_AUTH_KEY = "authorization";
export const REFERAL = "Referer";

export const GET_CATEGORIES_TYPE = {
    AMENITIES: 1,
    ADD_ONS: 2,
    ACTIVITES: 3,
    TAXATION: 4,
    TAGS: 5,
    CONTACT: 6,
};

export const BLOCK_STATUS_ENUMS = {
    category: 0,
    service: 1,
    banner: 2,
    user: 3,
    package: 4,
    employee: 5,
    discount: 6,
    taxation: 7,
    refundRule: 8,
};

export const APIS = {
    GET_DASHBOARD_DETAILS: "/admin/orders/sales-report",
    USERS: "/admin/emails",
    CHANGE_PASSWORD: "/admin/auth/changePassword",
    MY_RESTAURANTS: "/admin/restaurant",
    RESTAURANTS_LIST: "/admin/users",
    RESTAURANT_DETAILS: "/admin/users/details",
    ORDER_BY_USER: "/admin/orders/orders-via-user",
    UPLOAD_CATEGORY: "/admin/category",
    EDIT_CATEGORY: "/admin/category",
    MEALS: "/admin/meal",
    MEALS_WITH_PARAMS: "https://api.aptknutrition.com/admin/meal",
    CATEGORY: "/admin/category",
    PACKAGE: "/admin/package",
    ORDER: "/admin/orders",
    GET_ORDER: "/admin/orders/details",
    CANCEL_ORDER:"/admin/orders/cancel",
    UPDATE_ORDER: "/admin/orders",
    BLOCK: "/admin/enableDisableUser",
    DELETE_USER: "/admin/deleteUser",
    UPLOADS: "/admin/uploads",
    UPLOAD_STATUS: "/admin/uploadApproveReject",
    UPLOAD_CSV: "/admin/uploadCsv",
    GET_MOVIE: "/admin/getMovie",
    UPDATE_UPLOADS: "/admin/updateUpload",
    BLOCK_MOVIE: "/admin/activeInactiveMovie",
    SUBSCRIPTIONS: "/admin/subscriptionList",
    EDIT_SUBSCRIPTION: "/admin/editSubscription",
    EMAIL_NOTIFICATION: "/admin/sendEmail",
    SEND_NOTIFICATION: "/admin/notification",
    PAYOUT: "/admin/payouts",
    USERS_BANK_ACCOUNT: "/admin/usersBankAccount",
    GET_REVENUE: "/admin/revenue",
    SET_ADVERTISE_AMOUNT: "/admin/setAdAmount",
    UPDATE_RESTAURANT: "/admin/restaurant/update",
};
